import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Provider } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WindowRef } from 'src/app/lib/window-ref';
import { GlobalHeaderComponent } from './gui/global-header/global-header.component';
import { LoadingModalComponent } from './gui/loading-modal/loading-modal.component';
import { MailConfirmModalComponent } from './gui/mail-confirm-modal/mail-confirm-modal.component';
import { ReauthModalComponent } from './gui/reauth/reauth-modal.component';
import { ResetPasswordLinkComponent } from './gui/reset-password/reset-password-link.component';
import { SmsNotificationComponent } from './gui/sms-notification/sms-notification.component';
import { Initializer } from './initializer';
import { NoProfileAlertModalComponent } from './sign-in/no-profile-alert-modal/no-profile-alert-modal.component';

const firstPartyProviders: Provider = [
  CommonModule,
  RouterModule,
  HttpClientModule,
  FormsModule,
];

const initializerProviders: Provider[] = [
  Initializer,
  {
    provide: APP_INITIALIZER,
    useFactory: (initializer: Initializer) => () => initializer.init(),
    deps: [Initializer],
    multi: true,
  },
];

@NgModule({
  imports: [...firstPartyProviders],
  providers: [...initializerProviders, WindowRef],
  declarations: [
    GlobalHeaderComponent,
    ReauthModalComponent,
    MailConfirmModalComponent,
    ResetPasswordLinkComponent,
    NoProfileAlertModalComponent,
    LoadingModalComponent,
    SmsNotificationComponent,
  ],
  exports: [
    CommonModule,
    GlobalHeaderComponent,
    ReauthModalComponent,
    MailConfirmModalComponent,
    ResetPasswordLinkComponent,
    NoProfileAlertModalComponent,
    LoadingModalComponent,
    SmsNotificationComponent,
  ],
})
export class SharedModule {}
